import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from '../page/Header';
import Footer from '../page/Footer';
import ServicesPage from '../page/ServicesPage';
import JoinButton from '../buttons/JoinButton';

export default function Service() {
  
  useEffect(() => {
    // Scroll down after the component mounts
    window.scrollTo({
      top: 100, // Scrolls down 100px
      behavior: 'smooth'
    });

    // Use a timer to scroll back up after a short delay
    const scrollUpTimer = setTimeout(() => {
      window.scrollTo({
        top: 0, // Scrolls back to the top
        behavior: 'smooth'
      });
    }, 2000); // 2000 milliseconds = 2 seconds

    // Clean up the timer when the component unmounts
    return () => clearTimeout(scrollUpTimer);
  }, []);

  return (
    <>
      <Header />
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      
      <JoinButton/>
      <ServicesPage/>
      <Footer />
    </>
  );
}